import { Empty } from "antd-mobile";
import React from "react";
import { QuestionCircleOutline } from "antd-mobile-icons";
import useCustomTranslation from "@/hooks/useTranslation";

const CustomEmpty: React.FC = () => {
	const { t } = useCustomTranslation();
	return (
		<div className="empty-body">
			<Empty
				style={{ padding: "64px 0" }}
				image={
					<QuestionCircleOutline
						style={{
							color: "var(--adm-color-light)",
							fontSize: 48,
						}}
					/>
				}
				description={t("NoDataAvailable")}
			/>
		</div>
	);
};

export default CustomEmpty;
